import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import Safety from "@/pages/Safety";
import About from "@/pages/About";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import Verify from "@/pages/auth/Verify";
import Callback from "@/pages/auth/Callback";
import Forgot from "@/pages/auth/Forgot";
import Reset from "@/pages/auth/Reset";
import Legal from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";
import Dashboard from "@/pages/app/Dashboard";
import Onboarding from "@/pages/app/Onboarding";
import Decode from "@/pages/app/Decode";
import Coach from "@/pages/app/Coach";
import Learn from "@/pages/app/Learn";
import History from "@/pages/app/History";
import Trends from "@/pages/app/Trends";
import Children from "@/pages/app/Children";
import Account from "@/pages/app/Account";
import AppShell from "@/components/AppShell";
import NotFound from "@/pages/NotFound";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F4F6F4]">
        <div className="badge-soft" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/cookies" element={<Legal kind="cookies" />} />
            <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/signup" element={<Signup />} />
            <Route path="/auth/forgot" element={<Forgot />} />
            <Route path="/auth/reset/:token" element={<Reset />} />
            <Route path="/auth/verify/:token" element={<Verify />} />
            <Route path="/auth/callback" element={<Callback />} />
            <Route path="/app/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="decode" element={<Decode />} />
              <Route path="coach" element={<Coach />} />
              <Route path="learn" element={<Learn />} />
              <Route path="history" element={<History />} />
              <Route path="trends" element={<Trends />} />
              <Route path="children" element={<Children />} />
              <Route path="account" element={<Account />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
